<template>
  <div class="wrapper">
    <h1>Our Services</h1>
    <p class="content">
      We offer a <span>FREE CUSTOM DESIGN SERVICE</span>.There is no designing
      fee or any setup fee's for the printer. So already there you, the client,
      save on costs. We offer a <span>NO LIMIT ORDER</span> on quantity,
      irrespective if it is one or ten or more different designs or not.
      <br />
      Delivery can vary from 2-3 weeks BUT it can also take 4-5 weeks depending
      on where we fall in the que at the factory and our seamsters. OR any
      unforseen circumstances like machine failure or loadshedding.
    </p>
    <div class="list-wrapper">
      <div class="list">
        <img src="@/assets/done.webp" />
        <p>FREE CUSTOM DESIGN</p>
      </div>

      <div class="list">
        <img src="@/assets/done.webp" />
        <p>NO ARTWORK CHARGES</p>
      </div>

      <div class="list">
        <img src="@/assets/done.webp" />
        <p>NO SETUP COSTS FOR PRINTING</p>
      </div>

      <div class="list">
        <img src="@/assets/done.webp" />
        <p>NO QUANTITY LIMIT ON GARMENTS</p>
      </div>

      <div class="list">
        <img src="@/assets/done.webp" />
        <p>SUBLIMATION QUALITY GUARANTEED</p>
      </div>

      <div class="list">
        <img src="@/assets/done.webp" />
        <p>NO HIDDEN COSTS</p>
      </div>
    </div>
    <router-link to="/quote" class="CTA">Request a Quote</router-link>
    <div class="fishing-wrapper">
      <div class="fishing-title">
        <h1>FISHING HOODIES</h1>
        <p class="content">
          Pullover comes with kangaroo pocket zipped both sides OR Zipped Hoodie
          with front zipped / flap covered pockets. Addtional pocket on arm can
          be included as well.
        </p>
        <p class="content">
          Outer material is Oxford water repellent. The inner material is Micro
          Active-Superior Cire + Water repellent. The sleeves are Polyester
          Spandex quick dry Material (depends on environment conditions). The
          bottom of the Pullover and Zipped Hoodie is also Polyester Spandex
          Quick dry material (depends on environment conditions).
        </p>
      </div>

      <div class="fishing-container">
        <div class="fishing-grid">
          <div class="pullover">
            <div class="image flex-col">
              <img
                src="@/assets/hoodie3.webp"
                alt="custom design lighter image"
              />
            </div>
            <h4>Pullover Hoodies</h4>
          </div>
          <div class="zipped">
            <div class="image flex-col">
              <img src="@/assets/zipped.webp" alt="custom patterns image" />
            </div>
            <h4>Zipped Hoodies</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 

<style scoped>
.wrapper {
  padding: 1rem;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #000000;
}

.wrapper h1 {
  font-family: boombox, Helvetica, Arial, sans-serif;
  text-transform: uppercase;
  text-align: center;
  font-size: 1.75rem;
  margin-bottom: 0.5rem;
}

.list-wrapper {
  text-align: left;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  margin: 1rem 0;
  margin-bottom: 2rem;
}
.content {
  font-family: "Kanit", sans-serif;
  margin-top: 0.75rem;
  font-size: 1.1rem;
  font-weight: 600;
  text-align: left;
  max-width: 80ch;
}

.content span {
  color: #ee7c80;
}

.list {
  font-family: "Kanit", sans-serif;
  padding: 0 2rem;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  justify-content: left;
}

.CTA {
  font-family: boombox, Helvetica, Arial, sans-serif;
  text-transform: uppercase;
  box-shadow: rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset,
    rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset,
    rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset, rgba(0, 0, 0, 0.06) 0px 2px 1px,
    rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px,
    rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px;
  background-color: #fa4349;
  max-width: 350px;
  color: #fff;
  padding: 12px 25px;
  border-radius: 22px;
  font-size: 0.85rem;
  transition: all 0.25s ease-in-out;
}

.CTA:hover {
  transform: scale(1.05);
}

.list img {
  position: relative;
  width: 25px;
  top: -7px;
  margin-right: 0.5rem;
  margin-top: 10px;
}
/* ===============FISHING SECTION ========================== */
.fishing-wrapper {
  margin-top: 2rem;
}

.fishing-title h1 {
  font-family: boombox, Helvetica, Arial, sans-serif;
  text-transform: uppercase;
  font-size: 1.75rem;
  text-align: center;
  margin-top: 2rem;
}
.fishing-wrapper .content {
  margin: 1rem auto 2rem;
}
.fishing-image {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.fishing-image img {
  height: 100%;
  min-width: 100%;
  object-fit: cover;
  object-position: center;
  overflow: auto;
}
.fishing-container {
  font-family: boombox, Helvetica, Arial, sans-serif;
  text-align: center;
  text-transform: uppercase;
  max-width: 1300px;
  margin: 2rem auto;
}

.fishing-grid {
  display: grid;
  text-align: center;
  gap: 30px;
  position: relative;
  grid-template-columns: repeat(1, 1fr);
}

.flex-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.pullover,
.zipped {
  width: 100%;
  height: 100%;
  overflow: auto;
}

* > .image img {
  margin-bottom: 2rem;
  width: 75%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  filter: drop-shadow(6px 6px 4px rgba(0, 0, 0, 0.589));
}

/*============================== MEDIA QUERIES================== */
@media screen and (min-width: 500px) {
  .wrapper h1 {
    font-size: 2.25rem;
  }
  .fishing-grid {
    gap: 20px;
    grid-template-columns: repeat(2, 1fr);
    margin: 0 auto;
  }
  * > h4 {
    font-size: 0.9rem;
  }
}
@media screen and (min-width: 768px) {
  .CTA {
    font-size: 1rem;
  }
  * > h4 {
    font-size: 1.1rem;
  }
}
</style>